import { Button, Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import React from "react";
import { Field, Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { CheckboxComponent, TextFieldComponent } from "../../components/CustomFormElement";
import { AvatarFontIcon, ContactFontIcon, ErrorIcon, SuccessIcon } from "../../components/CustomIcons";
import CustomUploadFile from "../../components/CustomUploadFile";
import theme from '../../theme.css';
import validators from "../../utils/validators";
import CustomSection from '../../components/CustomSection';
import CustomCircularProgress from "../../components/CustomCircularProgress";

const useStyles = makeStyles((theme) => ({
    check_box: {
        padding: 0,
    },
    avatar: {
        verticalAlign: 'middle',
        width: theme.spacing(7),
        height: theme.spacing(7),
        borderRadius: '50%'
    },
    link: {
        color: theme.palette.primary.main,
        cursor: 'pointer',
    }
}));

export default function ContactInformationView(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const { avatar, contactInfo, files } = props;
    console.log("files===", files);

    return (
        <CustomSection notMarginTop={true}
            title={t('contact_information')}
            icon={<ContactFontIcon style={{
                color: theme.palette.common.white,
            }} />}
            customClass={classes.customClass}
        >
            <Grid item xs={12}>
                <Typography variant='body1'>{t('contact_information_desc')}</Typography>
            </Grid>
            {props.contactLoading && <CustomCircularProgress />}
            <Grid item xs={12} container direction='row' spacing={1} marginTop={2} style={{ padding: theme.spacing(1) }}>
                {/* <Grid item xs={3} style={{ textAlign: 'center' }}>
                    {avatar && avatar.preview ? <img src={avatar.preview} alt="Avatar" className={classes.avatar}></img> : <AvatarFontIcon style={{ width: 56, height: 56 }} />}
                    <Grid item xs={12} marginTop={2}>
                        <CustomUploadFile
                            name="avatar"
                            id="avatar"
                            buttonLabel={t('btn_add_image')}
                            onUploadFile={(files) => props.onAddImage(files)}
                            isPreview={false}
                        />
                    </Grid>
                </Grid> */}
                <Grid item xs={12}>
                    <FormContactInfo t={t} classes={classes}
                        contactInfo={contactInfo}
                        files={files}
                        validations={props.validations}
                        showLoadingEmail={props.showLoadingEmail}
                        attachments={props.attachments}
                        isSendDirectSale={props.isSendDirectSale}
                        isSendAffiliate={props.isSendAffiliate}
                        onSendDirectSale={props.onSendDirectSale}
                        onSendAffiliate={props.onSendAffiliate}
                        onSaveContactInfo={props.onSaveContactInfo}
                        onAddImage={props.onAddImage}
                        onOpenFile={props.onOpenFile}
                        onHandleBlur={props.onHandleBlur}
                        onCheckEmail={props.onCheckEmail}
                    />
                </Grid>
            </Grid>
        </CustomSection>
    );
}

function FormContactInfo(props) {
    const { t, classes, contactInfo, files, validations, showLoadingEmail } = props;
    console.log("AAAAAA contactInfo==", contactInfo);

    return (
        <Form
            onSubmit={props.onSaveContactInfo}
            initialValues={{ ...contactInfo, mobile_number: contactInfo && contactInfo.phone ? "0" + contactInfo.phone.number : null }}
            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                <Grid xs={12} container item justify="center" alignItems="center">
                    <Grid xs={12} item style={{ textAlign: 'center', width: '100%' }}>
                        <Grid xs={12} item >
                            <Field
                                fullWidth
                                name="first_name"
                                component={TextFieldComponent}
                                placeholder={t('first_name')}
                                validate={validators.composeValidators(validators.required)}
                            />
                        </Grid>
                        <Grid xs={12} item >
                            <Field
                                fullWidth
                                name="last_name"
                                component={TextFieldComponent}
                                placeholder={t('last_name')}
                                validate={validators.composeValidators(validators.required)}
                            />
                        </Grid>
                        <Grid xs={12} item container spacing={2}>
                            <Field
                                fullWidth
                                name="id_number"
                                component={TextFieldComponent}
                                placeholder={t('id_number')}
                                onCustomOnBlur={(e) => props.onHandleBlur(e.target.value, 'id_number')}
                                endAdornment={validations && validations.id_number === true ? <ErrorIcon /> : (validations.id_number === false && <SuccessIcon />)}
                            />
                        </Grid>
                        <Grid xs={12} item container spacing={2}>
                            <Field
                                fullWidth
                                name="passport_number"
                                component={TextFieldComponent}
                                placeholder={t('passport_number')}
                            />
                        </Grid>
                        <Grid xs={12} item >
                            <Field
                                fullWidth
                                name="email"
                                component={TextFieldComponent}
                                placeholder={t('email_address')}
                                validate={validators.composeValidators(validators.required)}
                                onCustomOnBlur={(email) => props.onCheckEmail(email)}
                                endAdornment={showLoadingEmail === true ? <CustomCircularProgress /> : validations && validations.email === true ? <ErrorIcon /> : (validations.email === false && <SuccessIcon />)}
                            />
                        </Grid>
                        <Grid item xs={12} >
                            <CustomUploadFile
                                name="file_contact"
                                id="file_contact"
                                // buttonLabel={t('btn_add_image')}
                                desc={t('file_contact')}
                                onUploadFile={(files) => props.onAddImage('file_contact', files)}
                                isPreview={true}
                                isMulti={true}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            {files && files.length > 0 && files.map((item, index) => {
                                let file = item.file ? item.file : null;
                                return (
                                    <Grid item xs={12} key={index}>
                                        <Typography className={classes.link} onClick={() => props.onOpenFile(file)}>{file.name}</Typography>
                                    </Grid>
                                );
                            })}
                        </Grid>
                        <Grid xs={12} item>
                            <Field
                                fullWidth
                                name="mobile_number"
                                component={TextFieldComponent}
                                placeholder={t('mobile_number') + ', eg: 0812345674*'}
                                validate={validators.composeValidators(validators.mustBeNumberRequired)}
                                onCustomOnBlur={(e) => props.onHandleBlur(e.target.value, 'phone')}
                                endAdornment={validations && validations.phone === true ? <ErrorIcon /> : (validations.phone === false && <SuccessIcon />)}
                            />
                        </Grid>

                        <Grid xs={12} item marginTop={3}>
                            <Box style={{ textAlign: 'left' }}>
                                <Button variant="contained" color="primary" size='small' onClick={handleSubmit} className={classes.button}>{t('btn_update')}</Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            )}
        />
    );
}